<script lang="ts">
  import { isUserLoggedIn, user } from "../app.store";
  import { logout } from "../app.logic";
  import { APP_TITLE } from "../utils/constants";

  let appTitle = APP_TITLE;
  let showUserMenu = true;
  $: userFullName = $user != null ? $user.fullName : "";
  $: companyName = "";
</script>

<nav class="navbar header-navbar noselect">
  <div class="container content header-content">
    <div class="navbar-brand header-brand">
      <i class="navbar-item app-logo">
        <!-- svelte-ignore a11y-img-redundant-alt -->
        <img src="/img/logo.png" alt="Logo" />
      </i>

      <span class="navbar-item brand-text header-brand-text">
        {appTitle}
      </span>

      <span class="navbar-item brand-text header-brand-text">
        {companyName}
      </span>
    </div>

    <div class="navbar-end">
      {#if $isUserLoggedIn}
        {#if showUserMenu}
          <a class="navbar-item header-user-name" href="/profile">
            {userFullName}
          </a>
        {/if}

        <div class="navbar-item">
          <div class="buttons">
            <button class="button is-light" on:click={logout}>
              <strong>Logout</strong>
            </button>
          </div>
        </div>
      {/if}
    </div>
  </div>
</nav>

<style>
  .header-navbar {
    background-color: #6fa132;
    border-bottom: 1px solid #5f9122;
    height: 4rem;
  }

  .header-content {
    max-width: unset !important;
    padding-left: 3rem;
    /* border-bottom: 1px solid #f2f2f2; */
    display: flex !important;
  }

  .header-brand {
    flex: 1;
  }

  .header-brand-text {
    font-weight: 300;
    padding-right: 5rem;
  }

  .header-user-name {
    border: none;
  }

  .header-user-name:hover,
  .header-user-name:focus,
  .header-user-name:focus-within {
    background-color: #ededed;
    outline: none;
  }

  .app-logo {
    background-color: #fafafa;
    border-radius: 3rem;
    width: 3rem;
    height: 3rem;
    margin-top: 0.5rem;
  }

  /*
  .header-brand-text:hover {
    color: #4a4a4a;
  }
  */

  .brand-text {
    font-weight: bold;
    font-size: large;
    color: #fafafa;
  }

  .header-user-name {
    font-weight: bold;
    font-size: medium;
    color: #fafafa;
  }
</style>
